import { produce } from 'immer';
import { StateCreatorWithDevtools } from '../store-utils';
import { PackageInfoModel } from '../../mvcapi/models/common/package-info-model';
import { AddTicketsToCartStore } from '../add-tickets-to-cart-store';

// INFO: New sale

export interface AddPackageToCartStoreSlice {

    /** Error that could happen during loading process of programs, event, event dates, ... */
    package: PackageInfoModel,

    loadPackage: (packageId: number) => Promise<void>,
}

export const AddPackageToCartStoreSliceDef: StateCreatorWithDevtools<AddPackageToCartStoreSlice & AddTicketsToCartStore, AddPackageToCartStoreSlice> = (set, get) => {
    return {
        // ****************
        // States
        // ****************
        package: null,

        
        // ****************
        // Actions
        // ****************
        loadPackage: async (packageId: number) => {
            console.log("Loading package ... ", packageId);

            // set({ eventDateId: eventDateId, fetchingEventDate: false, eventDate: null }, false, { type: "loadEventDate", eventDateId });

            // if (eventDateId) {
            //     set({ fetchingEventDate: true }, false, "loadEventDate/start");

                
            //     try {
            //         const result = await getEventDateInfo(eventDateId);

            //         set({ fetchingEventDate: false, eventDate: result }, false, "loadEventDate/success");

            //     } catch(err: any) {
            //         set({ fetchingEventDate: false, loadingError: err.message }, false, "loadEventDate/error");

            //         /*
            //         this.raiseContentChanged();
            //         */
            //     }
            // }
        },


    };
};

